<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      unit="人员标签"
      edit-title
      id-key="TagId"
      :data="data"
      :form-rules="rules"
      :save-func="()=>{}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-form-item label="标签名称" prop="TagName">
          <el-input v-model="data.TagName" placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="Sort">
          <el-input-number :min="0" v-model="data.Sort"></el-input-number>
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="row-tb-head">
          <span>人员列表</span>
          <div style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="addEmp">添加</el-button>
          </div>
        </div>
        <el-table class="tb-c-head" :data="data.Emps" border>
          <el-table-column label="人员名称" prop="TeacherName" />
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{row,$index}">
              <el-button type="text" @click="delEmp(row,$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <el-button type="primary" :loading="isLoading" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/fa/teacher/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
  },
  data() {
    return {
      data: {
        TagId: 0,
        TagName: "",
        Sort: 0,
        Status: 1,
        Emps: [],
      },
      DelEmps: [],
      api: require("@/api/ent/tag").default,
      rules: {
        TagName: [{ required: true, message: "标签名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.api.getMaxSort().then((res) => {
        this.data.Sort = res.Data;
      });
    },
    onEditOpened(data) {
      this.api.info(this.data.TagId).then((res) => {
        if (res.Data) this.data = { ...res.Data };
        this.data.Emps.forEach((x) => (x.T = null));
      });
    },
    addEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      this.data.Emps.push({
        TagEmpId: 0,
        TagId: this.data.TagId,
        TagName: this.data.TagName,
        TeacherId: data.TeacherId,
        TeacherName: data.TeacherName,
        T: 0,
      });
    },
    delEmp(row, index) {
      if (row.T != 0) this.DelEmps.push({ ...row, T: 2 });
      this.data.Emps.splice(index, 1);
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        var data = this.$commonJs.obj.removeNullKey(this.data);

        data.Emps = this.data.Emps.filter((x) => x.T != null);
        this.DelEmps.forEach((x) => data.Emps.push(x));
        data.Emps = data.Emps.map((x) => {
          return this.$commonJs.obj.removeNullKey(x);
        });

        console.log("api.save", data);
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.data.Emps = [];
      this.DelEmps = [];
    },
  },
};
</script>